const RoadmapCard = ({ id, title, desc }) => {
  return (
    <li className="roadmap-item">
      <div class={`content content-${id}`}>
        <h3 style={{ color: "var(--primary)" }}>{title}</h3>
        <p dangerouslySetInnerHTML={{ __html: desc }} />
      </div>
    </li>
  );
};

export default RoadmapCard;
